import "@theming/frontend.scss";
import "../store/all.scss";
import "@reactive_core/utils/initRailsUJS";
import "@reactive_core/utils/header";

import ReactOnRails from 'react-on-rails';
import App from '../components/App';

ReactOnRails.register({ App });
